<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="_switchIntegralObjType('')"
              :class="{'selected': integralDetailInfo.conditions.objType === ''}">
              {{ $t('common.all') }}
            </li>
            <li @click="_switchIntegralObjType('6006')"
              :class="{'selected': integralDetailInfo.conditions.objType === '6006'}">
              {{ $t('integralDetail.personal') }}
            </li>
            <li @click="_switchIntegralObjType('7007')"
              :class="{'selected': integralDetailInfo.conditions.objType === '7007'}">
              {{ $t('integralDetail.merchant') }}
            </li>
          </ul>
        </el-card>
      </el-col>
      <el-col :span="20">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('integralDetail.queryCondition') }}</span>
          </div>
          <el-form :inline="true" :model="integralDetailInfo.conditions" class="demo-form-inline text-left">
            <el-form-item>
              <el-input
                :placeholder="$t('integralDetail.accountPlaceholder')"
                v-model="integralDetailInfo.conditions.integralNameLike"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-select 
                v-model="integralDetailInfo.conditions.detailType" 
                :placeholder="$t('integralDetail.typePlaceholder')"
                style="width:100%">
                <el-option 
                  :label="$t('common.all')" 
                  value="">
                </el-option>
                <el-option 
                  :label="$t('integralDetail.transferIn')" 
                  value="1001">
                </el-option>
                <el-option 
                  :label="$t('integralDetail.transferOut')" 
                  value="2002">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select 
                v-model="integralDetailInfo.conditions.objType" 
                :placeholder="$t('integralDetail.objTypePlaceholder')"
                style="width:100%">
                <el-option 
                  :label="$t('common.all')" 
                  value="">
                </el-option>
                <el-option 
                  :label="$t('integralDetail.user')" 
                  value="6006">
                </el-option>
                <el-option 
                  :label="$t('integralDetail.merchant')" 
                  value="7007">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input
                :placeholder="$t('integralDetail.orderIdPlaceholder')"
                v-model="integralDetailInfo.conditions.orderId"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button 
                type="primary" 
                @click="_queryIntegralDetailMethod()"
                icon="el-icon-search">
                {{ $t('integralDetail.query') }}
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('integralDetail.integralTransaction') }}</span>
          </div>
          <div class="text item">
            <integral-detail-table 
              :integralDetails="integralDetailInfo.integralDetails">
            </integral-detail-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="integralDetailInfo.conditions.page"
              :page-size="integralDetailInfo.conditions.row"
              layout="total, prev, pager, next"
              :total="integralDetailInfo.total">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { listIntegralDetail } from '@/api/admin/integralDetail/integralDetailApi'
import IntegralDetailTable from '@/components/admin/integralDetail/integralDetailTable'

export default {
  name: 'IntegralDetail',
  components: {
    IntegralDetailTable
  },
  data() {
    return {
      integralDetailInfo: {
        integralDetails: [],
        total: 0,
        records: 1,
        moreCondition: false,
        detailId: '',
        conditions: {
          integralId: '',
          detailType: '',
          integralNameLike: '',
          amount: '',
          objType: '',
          orderId: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this._listIntegralDetails(1, 10)
    console.log(this.integralDetailInfo.moreCondition)
  },
  methods: {
    _listIntegralDetails(page, rows) {
      this.integralDetailInfo.conditions.page = page
      this.integralDetailInfo.conditions.row = rows
      
      listIntegralDetail(this.integralDetailInfo.conditions).then(res => {
        this.integralDetailInfo.total = res.total
        this.integralDetailInfo.records = res.records
        this.integralDetailInfo.integralDetails = res.data
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    _queryIntegralDetailMethod() {
      this._listIntegralDetails(1, 10)
    },
    _switchIntegralObjType(objType) {
      this.integralDetailInfo.conditions.objType = objType
      this._listIntegralDetails(1, 10)
    },
    handleCurrentChange(val) {
      this._listIntegralDetails(val, 10)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0 !important;
}
/* 使用全局 list-selector 样式，无需自定义样式 */
</style>